import { Injectable } from '@angular/core';
import { AuthProvider, GetUserDto } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LocalStorageService } from '../../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';
import { environment } from './../../../environments/environment';

const debug = Debug('aumico:aumico-project-reports:UsersNavigationService');

export interface INavigationService {
    updateNavigation(roles: string[]);
}

export interface INavigation {
    primaryNavigation: Array<any>;
    secondaryNavigation: Array<any>;
    user: any;
}

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class UsersNavigationService {
    public readyToRoute$ = new Subject<string>();

    constructor(private authProvider: AuthProvider, private localStorageService: LocalStorageService) {
        this.authProvider
            .getCurrentUser$()
            .pipe(
                filter((user) => user != null),
                untilDestroyed(this),
            )
            .subscribe((user: GetUserDto) => {
                this.updateUserLanguage(user);
                if (user.preferences != null) {
                    this.localStorageService.setUserPrefrences(user.preferences);
                }
            });
    }

    private updateUserLanguage(user: GetUserDto) {
        const userLanguage = user.locale;
        debug('user navigation, set language to: ', userLanguage);
        const appLanguage = this.localStorageService.getCurrentLanguageWithoutFallback();

        let routingLanguage: string;
        if (userLanguage != null) {
            routingLanguage = userLanguage;
        } else if (appLanguage != null) {
            routingLanguage = appLanguage;
        } else {
            routingLanguage = environment.defaultLanguage;
        }

        if (appLanguage != null && routingLanguage !== appLanguage) {
            debug('user navigation, set *** language to: ', routingLanguage);
            this.localStorageService.setCurrentLanguage(routingLanguage);
        }
        this.readyToRoute$.next(routingLanguage);
    }
}
